import { FindingType } from "@/common/api/findings/findings.model";
import {
  ApplicationType,
  DataSourceType,
} from "@/views/customize/data-sources/data/model";

export const audit_list: Array<{
  date: string;
  playbook: string;
  ran_by: string;
  date_source: DataSourceType;
  application: ApplicationType;
  information: string;
  findings: { id: FindingType; count: number };
}> = [
  {
    date: "2024-05-03T20:48:00.000Z",
    playbook: "Apply MPIP Labels",
    ran_by: "michael@cognnipolicies.onmicrosoft.com",
    date_source: "motion_365",
    application: "msft_sharepoint_365",
    information: "e34ebd2f-cd96-22ac-3059-952a7fe01e54",
    findings: { id: "sensitive_information", count: 457 },
  },

  {
    date: "2024-05-02T10:48:00.000Z",
    playbook: "Apply MPIP Labels",
    ran_by: "michael@cognnipolicies.onmicrosoft.com",
    date_source: "motion_365",
    application: "msft_sharepoint_365",
    information: "fd6a3357-4b1f-df40-d9f5-731e35302fe5",
    findings: { id: "sensitive_information", count: 385 },
  },
  {
    date: "2024-05-02T08:23:00.000Z",
    playbook: "Apply MPIP Labels",
    ran_by: "omri@cognnipolicies.onmicrosoft.com",
    date_source: "motion_365",
    application: "msft_sharepoint_365",
    information: "2ef1d9da-0ad7-450e-4b09-efd43581ce78",
    findings: { id: "sensitive_information", count: 391 },
  },
  {
    date: "2024-04-28T12:48:00.000Z",
    playbook: "Apply MPIP Labels",
    ran_by: "omri@cognnipolicies.onmicrosoft.com",
    date_source: "motion_365",
    application: "msft_sharepoint_365",
    information: "707babad-231f-82bb-014c-8506d3dc784e",
    findings: { id: "sensitive_information", count: 742 },
  },
  {
    date: "2024-04-28T10:20:00.000Z",
    playbook: "Apply MPIP Labels",
    ran_by: "omri@cognnipolicies.onmicrosoft.com",
    date_source: "motion_365",
    application: "msft_sharepoint_365",
    information: "45d2e54a-bf3f-a812-a8b6-5d247b9c3ff3",
    findings: { id: "sensitive_information", count: 41 },
  },
];
